<template>
  <div>
    <!-- <Users></Users> -->
    <UsersManagement></UsersManagement>
    <!-- <UserPasswordManagement :uid="userUID"> </UserPasswordManagement>  -->
  </div>
</template>

<script>
import Users from "@/components/main/user/users/component.vue";
import UsersManagement from "@/components/main/user/management/component.vue";
import UserPasswordManagement from "@/components/main/user/passwordmanagement/component.vue";
import BForm from "@/components/singles/BForm/component.vue";

export default {
  components: {
    Users,
    UsersManagement,
    UserPasswordManagement,
    BForm
  },
  data() {
    return {
      userUID: "",
      value: "",
      visible: false
    };
  },
  created() {},
  mounted() {
    this.userUID = this.$store.state.auth.user.uid;
  },
  methods: {
    trigger(result) {
      console.log("triggered", result);
    }
  }
};
</script>
